var _style, _rect, _g, _path, _path2, _path3, _g2, _ellipse, _ellipse2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333379;}\n\t.st1{fill:#EEF2F4;}\n\t.st2{opacity:0.28;fill:#333379;}\n\t.st3{fill:#022266;}\n\t.st4{fill:#32FD99;}\n\t.st5{opacity:0.15;}\n\t.st6{fill:#515151;}\n\t.st7{opacity:0.2;fill:#515151;}\n\t.st8{opacity:0.16;}\n\t.st9{fill:#A6FFD0;}\n\t.st10{opacity:0.12;fill:none;stroke:#022266;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{opacity:8.000000e-02;fill:#515151;}\n\t.st12{fill:none;stroke:#022266;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_9_",
    className: "st0",
    width: 1000,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.2,959.2c0,2.5-1.2,3.7-2.6,3.7c-1.1,0-1.9-0.5-2.1-1.4c-0.4,0.5-1,0.8-1.8,0.8c-1.5,0-2.6-1.2-2.6-2.8 c0-1.6,1.1-2.8,2.6-2.8c0.7,0,1.2,0.3,1.6,0.7v-0.5h1.6v3.9c0,0.8,0.3,1.4,1,1.4c0.9,0,1.7-0.9,1.7-3c0-3-2.3-5.3-5.4-5.3 c-3.1,0-5.6,2.4-5.6,5.7c0,3.3,2.5,5.7,5.9,5.7c1.1,0,2.1-0.2,2.9-0.4v0.6c-0.8,0.3-1.7,0.4-2.9,0.4c-3.7,0-6.5-2.6-6.5-6.2 c0-3.4,2.7-6.2,6.2-6.2C61.1,953.3,63.2,956.4,63.2,959.2z M58.3,959.5c0-0.8-0.6-1.4-1.3-1.4c-0.8,0-1.3,0.5-1.3,1.4 c0,0.8,0.6,1.3,1.3,1.3C57.8,960.9,58.3,960.3,58.3,959.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,955.1v2c-1.2-0.1-2.6,0.5-2.6,2.4v4.3h-1.9v-8.6h1.9v1.4C67.3,955.5,68.3,955.1,69.4,955.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.6,962.3c1,0,1.8-0.5,2.2-1.1l1.5,0.9c-0.8,1.2-2.1,1.9-3.8,1.9c-2.8,0-4.7-1.9-4.7-4.5 c0-2.5,1.8-4.5,4.5-4.5c2.6,0,4.3,2.1,4.3,4.5c0,0.3,0,0.5-0.1,0.8h-6.8C72.1,961.6,73.2,962.3,74.6,962.3z M76.9,958.8 c-0.3-1.5-1.3-2.1-2.5-2.1c-1.4,0-2.3,0.8-2.6,2.1H76.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.9,955.2v8.6h-1.9v-1.2c-0.7,0.9-1.7,1.5-3,1.5c-2.3,0-4.3-2-4.3-4.5c0-2.6,1.9-4.5,4.3-4.5 c1.3,0,2.3,0.5,3,1.4v-1.2H88.9z M87.1,959.5c0-1.6-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.1-2.7,2.7c0,1.6,1.2,2.7,2.7,2.7 C85.9,962.3,87.1,961.1,87.1,959.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.1,951.3H93v12.5h-1.9V951.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.9,955.2l-3.3,8.6h-2.1l-3.3-8.6h2l2.4,6.5l2.4-6.5H102.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.2,955.2h1.9v8.9c0,2.4-1.2,3.5-3.5,3.3v-1.8c1.1,0.1,1.7-0.3,1.7-1.5V955.2z M104,952.8 c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2c0,0.6-0.5,1.2-1.2,1.2C104.5,954,104,953.4,104,952.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116,955.2l-3.3,8.8c-0.8,2.2-2.2,3.3-4.2,3.2v-1.7c1.2,0.1,1.9-0.5,2.3-1.7l0.1-0.2l-3.6-8.4h2l2.6,6.2 l2.2-6.2H116z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C210.4,934.9,211.9,936.6,211.9,938.7z M210.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C209.8,941.6,210.9,940.3,210.9,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.5,940.8h-3.4l-0.6,1.7h-1.1l2.8-7.6h1.1l2.8,7.6h-1.1L219.5,940.8z M219.2,939.9l-1.4-3.8l-1.4,3.8 H219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.4,939.4v3.1h-1v-3.1l-2.7-4.5h1.1l2.1,3.6l2.1-3.6h1.1L226.4,939.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242,940.3c0,1.5-1.2,2.4-2.6,2.4c-1.1,0-2.1-0.5-2.5-1.6l0.9-0.5c0.2,0.8,0.8,1.1,1.7,1.1 c0.9,0,1.6-0.5,1.6-1.4c0-0.9-0.7-1.4-1.6-1.4h-2.2l0.3-4h4.2v0.9h-3.3l-0.1,2h1.1C240.8,937.9,242,938.7,242,940.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.6,934.9v7.6h-1V936l-1.6,0.5l-0.3-0.9l2-0.7H247.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C57.4,934.9,58.9,936.6,58.9,938.7z M57.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C56.8,941.6,57.9,940.3,57.9,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67,941.6v1h-4.6v-7.6h4.5v1h-3.5v2.3h3.2v0.9h-3.2v2.4H67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70,940.8l0.9-0.5c0.3,0.8,0.9,1.4,2,1.4c1.1,0,1.6-0.5,1.6-1.2c0-0.8-0.7-1-1.8-1.4 c-1.2-0.4-2.4-0.8-2.4-2.2c0-1.4,1.1-2.2,2.4-2.2c1.3,0,2.2,0.7,2.6,1.7l-0.8,0.5c-0.3-0.7-0.8-1.2-1.7-1.2 c-0.8,0-1.4,0.4-1.4,1.1c0,0.7,0.5,1,1.6,1.3c1.3,0.4,2.6,0.8,2.6,2.3c0,1.3-1.1,2.2-2.6,2.2C71.5,942.7,70.4,941.9,70,940.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80,934.9v7.6h-1v-7.6H80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.3,939.2c0,1.9-1.4,3.5-3.7,3.5c-2.4,0-4-1.8-4-4c0-2.2,1.7-4,4-4c1.4,0,2.7,0.8,3.3,1.8l-0.9,0.5 c-0.4-0.8-1.4-1.4-2.4-1.4c-1.8,0-3,1.3-3,3c0,1.7,1.2,3,3,3c1.6,0,2.5-0.9,2.7-2h-2.8v-0.9h3.8V939.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.6,934.9v7.6h-0.8l-3.9-5.7v5.7h-1v-7.6h0.8l3.9,5.7v-5.7H100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.1,941.6v1h-4.6v-7.6h4.5v1h-3.5v2.3h3.2v0.9h-3.2v2.4H109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.2,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C117.6,934.9,119.2,936.6,119.2,938.7z M118.2,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C117.1,941.6,118.2,940.3,118.2,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.2,940.4c0,1.2-1,2.2-2.2,2.2h-3.3v-7.6h3c1.2,0,2.1,0.9,2.1,2.1c0,0.7-0.3,1.2-0.8,1.6 C132.7,938.9,133.2,939.5,133.2,940.4z M128.7,935.8v2.3h2c0.6,0,1.1-0.5,1.1-1.2c0-0.6-0.5-1.2-1.1-1.2H128.7z M132.2,940.3 c0-0.7-0.5-1.2-1.2-1.2h-2.3v2.5h2.3C131.7,941.6,132.2,941,132.2,940.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.4,939.4v3.1h-1v-3.1l-2.7-4.5h1.1l2.1,3.6l2.1-3.6h1.1L139.4,939.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.6,951.9h2.1l2.6,9.7l2.8-9.7h1.9l2.8,9.7l2.6-9.7h2.1l-3.5,12.4h-2.4l-2.6-9l-2.6,9h-2.4L204.6,951.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.7,958.9v5.4h-1.9v-5.2c0-1.3-0.8-2.1-2-2.1c-1.3,0-2.2,0.7-2.2,2.5v4.7h-1.9v-12.4h1.9v4.7 c0.6-0.9,1.5-1.4,2.7-1.4C229.3,955.2,230.7,956.6,230.7,958.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.7,955.4v8.9h-1.9V963c-0.7,0.9-1.7,1.5-3.1,1.5c-2.4,0-4.4-2-4.4-4.7c0-2.6,2-4.7,4.4-4.7 c1.4,0,2.4,0.6,3.1,1.5v-1.3H241.7z M239.8,959.9c0-1.6-1.2-2.8-2.8-2.8c-1.6,0-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8 C238.6,962.7,239.8,961.5,239.8,959.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.9,951.4h1.9v12.9h-1.9V951.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.4,962.8c1.1,0,1.9-0.5,2.3-1.1l1.6,0.9c-0.8,1.2-2.1,1.9-3.9,1.9c-2.9,0-4.8-2-4.8-4.7 c0-2.6,1.9-4.7,4.7-4.7c2.6,0,4.4,2.1,4.4,4.7c0,0.3,0,0.5-0.1,0.8h-7C249.9,962.1,251,962.8,252.4,962.8z M254.7,959.1 c-0.3-1.5-1.4-2.2-2.5-2.2c-1.4,0-2.4,0.8-2.7,2.2H254.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M846.1,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C844.6,934.9,846.1,936.6,846.1,938.7z M845.2,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C844.1,941.6,845.2,940.3,845.2,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M849.3,938.7c0-2.2,1.7-4,3.9-4c2.2,0,4,1.8,4,4c0,2.2-1.7,4-4,4C851,942.7,849.3,940.9,849.3,938.7z  M856.1,938.7c0-1.7-1.3-3-2.9-3c-1.7,0-2.9,1.3-2.9,3c0,1.7,1.3,3,2.9,3C854.9,941.7,856.1,940.4,856.1,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M859.8,934.9h1.1l1.7,6.3l1.9-6.3h1l1.9,6.3l1.7-6.3h1.1l-2.2,7.6h-1.2l-1.8-6.1l-1.8,6.1H862L859.8,934.9z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M879.3,934.9v7.6h-0.8l-3.9-5.7v5.7h-1v-7.6h0.8l3.9,5.7v-5.7H879.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M887.5,941.6v1h-4.3v-7.6h1v6.7H887.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M889.9,938.7c0-2.2,1.7-4,3.9-4c2.2,0,4,1.8,4,4c0,2.2-1.7,4-4,4C891.6,942.7,889.9,940.9,889.9,938.7z  M896.8,938.7c0-1.7-1.3-3-2.9-3c-1.7,0-2.9,1.3-2.9,3c0,1.7,1.3,3,2.9,3C895.5,941.7,896.8,940.4,896.8,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M905.4,940.8H902l-0.6,1.7h-1.1l2.8-7.6h1.1l2.8,7.6H906L905.4,940.8z M905.1,939.9l-1.4-3.8l-1.4,3.8 H905.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M916.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C915.4,934.9,916.9,936.6,916.9,938.7z M915.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C914.9,941.6,915.9,940.3,915.9,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M926.5,935.8v2.5h3.2v1h-3.2v3.2h-1v-7.6h4.4v1H926.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M936.2,939.6h-1.8v2.9h-1v-7.6h3c1.3,0,2.4,1.1,2.4,2.4c0,1-0.7,1.9-1.6,2.2l1.8,3.1h-1.1L936.2,939.6z  M934.4,938.7h2c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4h-2V938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M941.9,938.7c0-2.2,1.7-4,3.9-4c2.2,0,4,1.8,4,4c0,2.2-1.7,4-4,4C943.6,942.7,941.9,940.9,941.9,938.7z  M948.8,938.7c0-1.7-1.3-3-2.9-3c-1.7,0-2.9,1.3-2.9,3c0,1.7,1.3,3,2.9,3C947.5,941.7,948.8,940.4,948.8,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M960.4,942.5h-1v-6l-2.5,4.2h-0.1l-2.5-4.1v5.9h-1v-7.6h1.1l2.4,4l2.4-4h1.1V942.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M839.3,952.9c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2 C839.9,954.1,839.3,953.6,839.3,952.9z M839.6,955.4h1.9v8.9h-1.9V955.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M843.7,951.4h1.9v12.9h-1.9V951.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M847.8,951.4h1.9v12.9h-1.9V951.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M852,951.4h1.9v12.9H852V951.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M864,955.4v8.9h-1.9v-1.1c-0.6,0.9-1.5,1.4-2.7,1.4c-2,0-3.4-1.3-3.4-3.6v-5.4h1.9v5.2c0,1.3,0.8,2.1,2,2.1 c1.3,0,2.2-0.7,2.2-2.5v-4.7H864z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M872.6,961.8c0,1.8-1.5,2.7-3.5,2.7c-1.8,0-3-0.8-3.6-2.1l1.6-1c0.3,0.8,1,1.3,2,1.3c0.8,0,1.5-0.3,1.5-1 c0-1.6-4.8-0.7-4.8-3.9c0-1.7,1.4-2.7,3.2-2.7c1.5,0,2.7,0.7,3.3,1.8l-1.6,0.9c-0.3-0.7-0.9-1-1.7-1c-0.7,0-1.3,0.3-1.3,0.9 C867.9,959.5,872.6,958.5,872.6,961.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M876.7,957.3v4.2c0,1.1,0.7,1.1,2.2,1v1.7c-2.9,0.4-4.1-0.5-4.1-2.8v-4.2h-1.6v-1.8h1.6v-1.9l1.9-0.6v2.5 h2.2v1.8H876.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M885.4,955.3v2.1c-1.3-0.1-2.7,0.5-2.7,2.5v4.5h-1.9v-8.9h1.9v1.5C883.2,955.7,884.2,955.3,885.4,955.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M895.3,955.4v8.9h-1.9V963c-0.7,0.9-1.7,1.5-3.1,1.5c-2.4,0-4.4-2-4.4-4.7c0-2.6,2-4.7,4.4-4.7 c1.4,0,2.4,0.6,3.1,1.5v-1.3H895.3z M893.4,959.9c0-1.6-1.2-2.8-2.8-2.8c-1.6,0-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8 C892.2,962.7,893.4,961.5,893.4,959.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M900.3,957.3v4.2c0,1.1,0.7,1.1,2.2,1v1.7c-2.9,0.4-4.1-0.5-4.1-2.8v-4.2h-1.6v-1.8h1.6v-1.9l1.9-0.6v2.5 h2.2v1.8H900.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M903.9,952.9c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2 C904.5,954.1,903.9,953.6,903.9,952.9z M904.2,955.4h1.9v8.9h-1.9V955.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M907.8,959.9c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7 C909.9,964.5,907.8,962.5,907.8,959.9z M915.3,959.9c0-1.6-1.2-2.8-2.8-2.8c-1.6,0-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8 C914.1,962.7,915.3,961.5,915.3,959.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M927,958.9v5.4h-1.9v-5.2c0-1.3-0.8-2.1-2-2.1c-1.3,0-2.2,0.7-2.2,2.5v4.7h-1.9v-8.9h1.9v1.1 c0.6-0.9,1.5-1.4,2.7-1.4C925.5,955.2,927,956.6,927,958.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M935.5,961.8c0,1.8-1.5,2.7-3.5,2.7c-1.8,0-3-0.8-3.6-2.1l1.6-1c0.3,0.8,1,1.3,2,1.3c0.8,0,1.5-0.3,1.5-1 c0-1.6-4.8-0.7-4.8-3.9c0-1.7,1.4-2.7,3.2-2.7c1.5,0,2.7,0.7,3.3,1.8l-1.6,0.9c-0.3-0.7-0.9-1-1.7-1c-0.7,0-1.3,0.3-1.3,0.9 C930.7,959.5,935.5,958.5,935.5,961.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M936.8,963.2c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3 C937.4,964.5,936.8,963.9,936.8,963.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M940.3,959.9c0-2.6,2-4.7,4.7-4.7c1.7,0,3.2,0.9,3.9,2.3l-1.6,1c-0.4-0.8-1.3-1.4-2.3-1.4 c-1.6,0-2.7,1.2-2.7,2.8c0,1.6,1.2,2.8,2.7,2.8c1.1,0,1.9-0.5,2.4-1.4l1.6,0.9c-0.7,1.4-2.2,2.3-4,2.3 C942.3,964.5,940.3,962.5,940.3,959.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M949.7,959.9c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7 C951.8,964.5,949.7,962.5,949.7,959.9z M957.2,959.9c0-1.6-1.2-2.8-2.8-2.8s-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8 S957.2,961.5,957.2,959.9z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st2",
    d: "M399,253c-47.4,3.2-50.1,67.2-138,116c-71.5,39.7-107.2,18.1-129.5,47.7 C73.7,493.5,213.5,772,375,785c78.4,6.3,94.6-55.4,252-94c127.3-31.2,162.2-2,208-40c107.3-89,59.3-368.3-21.5-388.3 c-69.2-17.2-129.5,164.5-230,150C494.7,399.9,472.5,248,399,253z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st3",
    d: "M619.9,346.3c4,26.4,0,67,28.9,88.6c27.5,20.5,50.2,15.4,50.2,15.4 C701.7,440.5,736.5,344.7,619.9,346.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st4",
    d: "M776.2,352.5c-24.7,10-65.2,15.6-79.4,48.8c-4.8,11.2-6.6,21.1-6.9,29.2 c-6.9,15.3-13.5,27.8-19.9,38c-20.6,32.7-38.3,41.2-52.1,41.6c-28.1,0.8-38-32.4-108-92c-47.6-40.6-75.3-63.5-118-70 c-56.6-8.6-100.8,17.8-107.2,21.8c-12.3,7.6-47.5,29.2-60.8,70.2c-26.3,81.2,54.7,156.6,63.8,164.8c38.9,35.2,81.5,45.4,105,51 c15.2,3.6,68.8,15.1,135.2-1.4c38.2-9.5,111-27.6,154-96.4c22.5-36,29.1-73.5,29.6-104C742.4,452.9,798.6,440.4,776.2,352.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_41_",
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_87_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_91_",
    className: "st6",
    d: "M776.2,352.5c-3.3,1.4-7,2.6-10.8,3.9c17.8,81-36,93.2-66,94.4c-0.3,30.5-6.7,68-28.9,104.1 C628,624,555.2,642.5,517.1,652.3c-43.3,11-81.2,10.1-106.5,7.2c24.5,4,67.3,7.4,117.3-5c38.2-9.5,111-27.6,154-96.4 c22.5-36,29.1-73.5,29.6-104C742.4,452.9,798.6,440.4,776.2,352.5z"
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_18_",
    className: "st7",
    cx: 253.9,
    cy: 460.6,
    rx: 11,
    ry: 12.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_23_",
    className: "st7",
    cx: 331.1,
    cy: 447.8,
    rx: 11.2,
    ry: 12.9
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_",
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_88_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_89_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    className: "st6",
    d: "M271.2,389.3c5.4-3.3,50.5-28.9,107.2-21.8c50.7,6.4,84.5,35.7,117.3,64.2 c62.9,54.6,95.2,94.5,124.2,88.7c13.6-2.7,22.3-9.8,36.6-32.4c0.7-1.1,1.4-2.2,2-3.3c-15.7,19.5-29.5,25.1-40.6,25.4 c-28.1,0.8-38-32.4-108-92c-47.6-40.6-75.3-63.5-118-70c-56.6-8.6-100.8,17.8-107.2,21.8c-10.4,6.4-36.9,22.7-53,52.1 C246.5,404.6,263.4,394.2,271.2,389.3z"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st9",
    d: "M527.9,654.4c29.3-7.3,78.9-19.6,119.9-56c-80.6,34.4-133.2,28.3-167.9,13.6 c-82.3-35-104.8-136.7-174-134c-18.4,0.7-42.8,8.4-54,28c-13.6,23.9-0.6,52.5,1.5,57c6.7,11,17.7,26.5,34.3,41.8 c37.8,34.8,79.3,44.9,105,51C407.9,659.5,461.5,670.9,527.9,654.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st10",
    d: "M302.5,478c0,0,47,112,176.5,139"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    className: "st11",
    d: "M536.1,644.6c-66.4,16.5-120,5.1-135.2,1.4c-25.7-6.2-67.2-16.2-105-51 c-16.6-15.3-27.6-30.8-34.3-41.8c-2.1-4.5-15.1-33.1-1.5-57c0.2-0.4,0.5-0.8,0.8-1.3c-3.5,3.2-6.5,6.9-8.9,11.1 c-13.6,23.9-0.6,52.5,1.5,57c6.7,11,17.7,26.5,34.3,41.8c37.8,34.8,79.3,44.9,105,51c15.2,3.6,68.8,15.1,135.2-1.4 c29.3-7.3,78.9-19.6,119.9-56c-3,1.3-6,2.5-9,3.7C601.8,628.2,561.3,638.3,536.1,644.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st10",
    d: "M253.9,507.8c0,0,19.1,73.4,99.1,114.7c59,30.5,153.3,46.7,270.9-8.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st10",
    d: "M269.1,488.7c0,0,65.4,202.3,338.3,126.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st12",
    d: "M527.9,654.4c29.3-7.3,78.9-19.6,119.9-56c-80.6,34.4-133.2,28.3-167.9,13.6 c-82.3-35-104.8-136.7-174-134c-18.4,0.7-42.8,8.4-54,28c-13.6,23.9-0.6,52.5,1.5,57c6.7,11,17.7,26.5,34.3,41.8 c37.8,34.8,79.3,44.9,105,51C407.9,659.5,461.5,670.9,527.9,654.4z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_4_",
    className: "st3",
    cx: 250.8,
    cy: 459.8,
    rx: 9.1,
    ry: 11.8
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6_",
    className: "st13",
    cx: 249.4,
    cy: 454.4,
    rx: 3.1,
    ry: 4.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_11_",
    className: "st3",
    cx: 327.6,
    cy: 446.8,
    rx: 9.1,
    ry: 11.8
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_10_",
    className: "st13",
    cx: 326.4,
    cy: 442,
    rx: 3.3,
    ry: 4.8
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_16_",
    className: "st13",
    cx: 328,
    cy: 452.7,
    rx: 1.6,
    ry: 2.4
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_21_",
    className: "st13",
    cx: 252.5,
    cy: 464.6,
    rx: 1.6,
    ry: 2.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st12",
    d: "M776.2,352.5c-24.7,10-65.2,15.6-79.4,48.8c-4.8,11.2-6.6,21.1-6.9,29.2 c-6.9,15.3-13.5,27.8-19.9,38c-20.6,32.7-38.3,41.2-52.1,41.6c-28.1,0.8-38-32.4-108-92c-47.6-40.6-75.3-63.5-118-70 c-56.6-8.6-100.8,17.8-107.2,21.8c-12.3,7.6-47.5,29.2-60.8,70.2c-26.3,81.2,54.7,156.6,63.8,164.8c38.9,35.2,81.5,45.4,105,51 c15.2,3.6,68.8,15.1,135.2-1.4c38.2-9.5,111-27.6,154-96.4c22.5-36,29.1-73.5,29.6-104C742.4,452.9,798.6,440.4,776.2,352.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st4",
    d: "M499.9,562c0,0,56.3,64.9,14,142c-26,26-48.8-56-48.8-82s8.8-40.7,8.8-40.7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st7",
    d: "M499.9,562l-1.3,0.9c13.9,23.8,33.1,72,3.3,126.4c-6.1,6.1-12,6.3-17.5,2.6 c8.3,14.9,18.7,23,29.5,12.1C556.2,626.9,499.9,562,499.9,562z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st12",
    d: "M499.9,562c0,0,56.3,64.9,14,142c-26,26-48.8-56-48.8-82s8.8-40.7,8.8-40.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st2",
    d: "M584.7,243c0,0-41-8-41,34s66,50,84,32s49.7-48.9,32-66.6S584.7,243,584.7,243z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st2",
    d: "M206.5,297.4c-2.3-0.3-15-1.8-19.9,5.1c-6.1,8.5,3.3,24.8,14.4,32.5c7.5,5.2,23.1,11.5,32.1,3.2 c8.4-7.7,6.5-24.1-2.1-33.2C221.8,295.3,207.9,297.2,206.5,297.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhale);
export default __webpack_public_path__ + "static/media/whale.21799c4005a118cd1e9f5aa43f6dfd9d.svg";
export { ForwardRef as ReactComponent };